<template>
<v-textarea rows="1" auto-grow clearable type="text" maxlength="50" :label="label || 'توضیحات'" v-model="internalValue" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
export default {
  name: 'MyComment',
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      internalValue: this.value
    }
  },
  watch: {
    value(val) {
      this.internalValue = val
    },
    internalValue(val) {
      this.$emit('input', val)
    }
  },
}
</script>
